const BlogStyles = () => {
  return (
    <style jsx>{`
      .blogs-page {
        font-family:
          -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }

      /* Hero Section - Same as home page */
      .blogs-hero {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        padding: 100px 0 80px;
        position: relative;
        overflow: hidden;
      }

      .blogs-hero::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:
          radial-gradient(
            circle at 20% 80%,
            rgba(255, 215, 0, 0.1) 0%,
            transparent 50%
          ),
          radial-gradient(
            circle at 80% 20%,
            rgba(255, 255, 255, 0.05) 0%,
            transparent 50%
          );
      }

      .hero-content {
        max-width: 800px;
        margin: 0 auto;
        text-align: center;
        position: relative;
        z-index: 1;
      }

      .hero-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 24px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .badge-icon {
        font-size: 20px;
      }

      .badge-text {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .hero-title {
        font-size: clamp(2.5rem, 5vw, 3.5rem);
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
        word-wrap: break-word;
      }

      .highlight {
        background: linear-gradient(90deg, #ffd700 0%, #ffec8b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .hero-subtitle {
        font-size: 1.25rem;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.9);
        max-width: 600px;
        margin: 0 auto 40px;
      }

      /* Search Container */
      .search-container {
        max-width: 700px;
        margin: 0 auto;
      }

      .search-wrapper {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 16px;
        padding: 4px;
        display: flex;
        align-items: center;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .search-icon {
        padding: 0 16px;
        font-size: 20px;
        color: rgba(255, 255, 255, 0.7);
      }

      .search-input {
        flex: 1;
        background: transparent;
        border: none;
        color: white;
        font-size: 16px;
        padding: 16px 0;
        outline: none;
      }

      .search-input::placeholder {
        color: rgba(255, 255, 255, 0.6);
      }

      .search-stats {
        background: rgba(255, 255, 255, 0.2);
        padding: 8px 16px;
        border-radius: 12px;
        margin: 0 4px;
        text-align: center;
        min-width: 140px;
      }

      .stat-count {
        display: block;
        font-size: 24px;
        font-weight: 700;
        color: #ffd700;
      }

      .stat-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        display: block;
      }

      /* Category Filter */
      .category-filter {
        padding: 30px 0;
        background: white;
        border-bottom: 1px solid #f0f2f5;
        position: sticky;
        top: 0;
        z-index: 100;
        backdrop-filter: blur(10px);
      }

      .filter-wrapper {
        display: flex;
        align-items: center;
        gap: 24px;
        flex-wrap: wrap;
      }

      .filter-label {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        color: #0a2458;
        white-space: nowrap;
      }

      .filter-icon {
        font-size: 20px;
      }

      .filter-buttons {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }

      .filter-btn {
        padding: 10px 20px;
        border: 1px solid #e2e8f0;
        background: white;
        color: #0a2458;
        border-radius: 50px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .filter-btn:hover {
        border-color: #0a2458;
        color: #0a2458;
      }

      .filter-btn.active {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-color: #0a2458;
      }

      .category-count {
        background: rgba(255, 255, 255, 0.2);
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 12px;
        min-width: 24px;
        text-align: center;
      }

      /* Section Headers */
      .section-header {
        text-align: center;
        margin-bottom: 60px;
      }

      .section-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(10, 36, 88, 0.1);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 16px;
      }

      .section-title {
        font-size: clamp(2rem, 4vw, 2.5rem);
        color: #0a2458;
        margin-bottom: 16px;
      }

      .section-subtitle {
        font-size: 1.125rem;
        color: #0a2458;
        max-width: 600px;
        margin: 0 auto;
        line-height: 1.6;
      }

      /* Featured Posts */
      .featured-posts {
        padding: 80px 0;
        background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
      }

      .featured-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
        gap: 40px;
      }

      @media (max-width: 768px) {
        .featured-grid {
          grid-template-columns: 1fr;
        }
      }

      .featured-card {
        background: white;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(10, 36, 88, 0.08);
        transition: all 0.3s ease;
        cursor: pointer;
      }

      .featured-card:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 40px rgba(10, 36, 88, 0.15);
      }

      .card-image {
        position: relative;
        height: 300px;
        overflow: hidden;
      }

      .card-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .featured-card:hover .card-image img {
        transform: scale(1.05);
      }

      .card-badge {
        position: absolute;
        top: 20px;
        left: 20px;
        background: #0a2458;
        color: white;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
      }

      .card-content {
        padding: 32px;
      }

      .post-meta {
        display: flex;
        gap: 16px;
        margin-bottom: 16px;
        font-size: 14px;
        color: #0a2458;
      }

      .post-title {
        font-size: 1.75rem;
        color: #0a2458;
        margin-bottom: 16px;
        line-height: 1.3;
      }

      .post-excerpt {
        font-size: 1rem;
        color: #0a2458;
        line-height: 1.6;
        margin-bottom: 24px;
      }

      .post-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 24px;
        border-top: 1px solid #f1f5f9;
      }

      .author-info {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .author-avatar {
        width: 40px;
        height: 40px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
      }

      .author-details {
        display: flex;
        flex-direction: column;
      }

      .author-name {
        font-weight: 600;
        color: #0a2458;
      }

      .author-role {
        font-size: 12px;
        color: #0a2458;
      }

      .read-more-btn {
        background: transparent;
        border: none;
        color: #0a2458;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: all 0.3s ease;
      }

      .read-more-btn:hover {
        gap: 12px;
        color: #1a3b8a;
      }

      /* All Posts */
      .all-posts {
        padding: 80px 0;
        background: white;
      }

      .posts-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 32px;
      }

      .post-card {
        background: white;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
        cursor: pointer;
        border: 1px solid #f1f5f9;
      }

      .post-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 30px rgba(10, 36, 88, 0.1);
        border-color: #0a2458;
      }

      .post-image {
        position: relative;
        height: 200px;
        overflow: hidden;
      }

      .post-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .category-tag {
        position: absolute;
        top: 12px;
        left: 12px;
        background: rgba(10, 36, 88, 0.9);
        color: white;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 600;
      }

      .post-content {
        padding: 24px;
      }

      .post-meta {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        color: #0a2458;
        margin-bottom: 12px;
      }

      .dot {
        color: #cbd5e0;
      }

      .post-title {
        font-size: 1.25rem;
        color: #0a2458;
        margin-bottom: 12px;
        line-height: 1.4;
      }

      .post-excerpt {
        font-size: 0.875rem;
        color: #0a2458;
        line-height: 1.6;
        margin-bottom: 20px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .post-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 16px;
        border-top: 1px solid #f1f5f9;
      }

      .author {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        color: #0a2458;
      }

      .author-initials {
        width: 28px;
        height: 28px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 600;
      }

      .read-more {
        color: #0a2458;
        font-size: 13px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 4px;
      }

      /* No Results */
      .no-results {
        text-align: center;
        padding: 80px 20px;
      }

      .no-results-icon {
        font-size: 64px;
        margin-bottom: 24px;
        opacity: 0.5;
      }

      .no-results h3 {
        font-size: 1.75rem;
        color: #0a2458;
        margin-bottom: 16px;
      }

      .no-results p {
        color: #0a2458;
        margin-bottom: 32px;
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
      }

      .reset-btn {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border: none;
        padding: 12px 32px;
        border-radius: 8px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .reset-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 20px rgba(10, 36, 88, 0.2);
      }

      /* Newsletter */
      .newsletter-section {
        padding: 80px 0;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
      }

      .newsletter-card {
        background: white;
        border-radius: 24px;
        padding: 60px;
        display: grid;
        grid-template-columns: 2fr 1fr;
        gap: 60px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
      }

      @media (max-width: 768px) {
        .newsletter-card {
          grid-template-columns: 1fr;
          padding: 40px 24px;
          gap: 40px;
        }
      }

      .newsletter-content {
        text-align: center;
      }

      .newsletter-icon {
        font-size: 48px;
        margin-bottom: 24px;
      }

      .newsletter-content h2 {
        font-size: 2rem;
        color: #0a2458;
        margin-bottom: 16px;
      }

      .newsletter-content p {
        color: #0a2458;
        line-height: 1.6;
        margin-bottom: 32px;
      }

      .newsletter-form {
        display: flex;
        gap: 12px;
        margin-bottom: 24px;
      }

      .newsletter-form input {
        flex: 1;
        padding: 16px 24px;
        border: 2px solid #e2e8f0;
        border-radius: 12px;
        font-size: 16px;
        outline: none;
        transition: all 0.3s ease;
      }

      .newsletter-form input:focus {
        border-color: #0a2458;
      }

      .subscribe-btn {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border: none;
        padding: 16px 32px;
        border-radius: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .subscribe-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 20px rgba(10, 36, 88, 0.3);
      }

      .newsletter-note {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0a2458;
        font-size: 14px;
        justify-content: center;
      }

      .newsletter-stats {
        display: flex;
        flex-direction: column;
        gap: 24px;
        justify-content: center;
      }

      .stat-item {
        text-align: center;
      }

      .stat-number {
        font-size: 2.5rem;
        font-weight: 700;
        color: #0a2458;
        margin-bottom: 4px;
      }

      .stat-label {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }

      /* Topics */
      .topics-section {
        padding: 80px 0;
        background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
      }

      .topics-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 32px;
      }

      .topic-card {
        background: white;
        border-radius: 20px;
        padding: 32px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
        cursor: pointer;
        border: 2px solid transparent;
      }

      .topic-card:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 40px rgba(10, 36, 88, 0.1);
        border-color: #0a2458;
      }

      .topic-icon {
        width: 64px;
        height: 64px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        margin-bottom: 24px;
      }

      .topic-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
      }

      .topic-header h3 {
        font-size: 1.25rem;
        color: #0a2458;
        margin: 0;
      }

      .topic-count {
        background: rgba(10, 36, 88, 0.1);
        color: #0a2458;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
      }

      .topic-card p {
        color: #0a2458;
        line-height: 1.6;
        margin-bottom: 24px;
      }

      .topic-link {
        color: #0a2458;
        font-weight: 600;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      /* CTA */
      .blog-cta {
        padding: 80px 0;
        background: white;
      }

      .cta-card {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        border-radius: 24px;
        padding: 60px;
        color: white;
        display: grid;
        grid-template-columns: 2fr 1fr;
        gap: 60px;
      }

      @media (max-width: 768px) {
        .cta-card {
          grid-template-columns: 1fr;
          padding: 40px 24px;
          gap: 40px;
        }
      }

      .cta-content h2 {
        font-size: 2.5rem;
        margin-bottom: 20px;
        line-height: 1.2;
      }

      .cta-content p {
        font-size: 1.125rem;
        opacity: 0.9;
        margin-bottom: 32px;
        line-height: 1.6;
      }

      .cta-buttons {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
      }

      .cta-primary {
        background: white;
        color: #0a2458;
        border: none;
        padding: 16px 32px;
        border-radius: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .cta-primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
      }

      .cta-secondary {
        background: transparent;
        color: white;
        border: 2px solid rgba(255, 255, 255, 0.3);
        padding: 16px 32px;
        border-radius: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .cta-secondary:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: white;
      }

      .cta-image {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .cta-stats {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 20px;
        padding: 32px;
        display: grid;
        grid-template-columns: 1fr;
        gap: 24px;
      }

      .stat {
        text-align: center;
      }

      .stat-value {
        font-size: 2.5rem;
        font-weight: 700;
        color: #ffd700;
        margin-bottom: 4px;
      }

      .stat-label {
        font-size: 14px;
        opacity: 0.9;
      }

      /* Responsive */
      @media (max-width: 768px) {
        .blogs-hero {
          padding: 60px 0 40px;
        }

        .search-wrapper {
          flex-direction: column;
          background: rgba(255, 255, 255, 0.05);
        }

        .search-stats {
          width: 100%;
          margin: 8px 0 0 0;
        }

        .filter-wrapper {
          flex-direction: column;
          align-items: flex-start;
        }

        .filter-buttons {
          width: 100%;
          overflow-x: auto;
          padding-bottom: 8px;
        }

        .featured-posts,
        .all-posts,
        .newsletter-section,
        .topics-section,
        .blog-cta {
          padding: 60px 0;
        }

        .posts-grid,
        .topics-grid {
          grid-template-columns: 1fr;
        }
      }
    `}</style>
  );
};
export default BlogStyles;
